import { DEFAULT_PARTNER } from 'constants/partner'
import VPErrorImage from 'App/Main/Error/assets/error_VP.png'
import PRVErrorImage from 'App/Main/Error/assets/error_PRV.png'
import { GetErrorImage } from './errors.types'

const imagePaths = {
  [DEFAULT_PARTNER]: VPErrorImage,
  EBT: VPErrorImage,
  PRV: PRVErrorImage,
  VEX: VPErrorImage
}

export const getErrorImage: GetErrorImage = (partner) =>
  partner !== undefined && imagePaths[partner]
    ? imagePaths[partner]
    : imagePaths[DEFAULT_PARTNER]
